export default __webpack_public_path__ + "img/a28a4f7d072b8de61e56863b4e627394.png";